import React, { PureComponent, Component } from 'react';
import { ThemeProvider } from './ThemeContext';
import { color as lightTheme } from '../core-res/ThemeDefault';
import { color as darkTheme } from '../core-res/ThemeDark';
const ThemeAPIContext = React.createContext({
    name: 'light',
    color: lightTheme,
    set: () => {
        console.warn('setTheme: cannot find closest Provider. Make sure to wrap your component with <ThemeProvider /> before calling setTheme.');
    },
});
/**
 * withThemeAPI HOC
 */
function withThemeAPI(WrappedComponent) {
    return class ThemeAPIComponent extends Component {
        render() {
            return (<ThemeAPIContext.Consumer>
          {themeAPI => <WrappedComponent {...this.props} themeAPI={themeAPI}/>}
        </ThemeAPIContext.Consumer>);
        }
    };
}
class ThemeManager extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeThemeName: 'light',
        };
    }
    render() {
        const { children, themeConfig, themeName, onChange } = this.props;
        const { activeThemeName } = this.state;
        const isControlled = typeof themeName !== 'undefined';
        const currentThemeName = isControlled ? themeName : activeThemeName;
        const themeAPI = {
            name: currentThemeName,
            color: currentThemeName === 'light' ? themeConfig.light : themeConfig.dark,
            set: nextThemeName => {
                if (!isControlled) {
                    this.setState({
                        activeThemeName: nextThemeName,
                    });
                }
                if (typeof onChange === 'function') {
                    onChange(nextThemeName);
                }
            },
        };
        return (<ThemeAPIContext.Provider value={themeAPI}>
        <ThemeProvider value={themeAPI.color}>{children}</ThemeProvider>
      </ThemeAPIContext.Provider>);
    }
}
ThemeManager.defaultProps = {
    themeConfig: {
        light: lightTheme,
        dark: darkTheme,
    },
};
export { ThemeAPIContext, withThemeAPI, ThemeManager };
